export default (theme) => ({
    root: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'relative',
        marginLeft: -2,
    },
    rectangularFM: {
        position: 'absolute',
        left: 42,
        top: '50%',
        marginTop: -9,
        opacity: 0,
        width: 20,
        willChange: 'opacity',
        transition: 'all .4s ease',
    },
    rectangularAdmin: {
        position: 'absolute',
        left: 42,
        top: '50%',
        marginTop: -13,
        opacity: 0,
        width: 20,
        willChange: 'opacity',
        transition: 'all .4s ease',
    },
    customRectangular: {
        position: 'absolute',
        left: 30,
        opacity: 0,
        height: 25,
        width: 20,
        marginTop: 'unset',
        transform: 'translate3d(0, -50%, 0)',
        willChange: 'opacity',
        transition: 'all .4s ease',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'left center',
    },
    isExpanded: {
        '& $rectangularFM': {
            opacity: 1,
            width: 142,
        },
        '& $rectangularAdmin': {
            opacity: 1,
            width: 142,
        },
        '& $customRectangular': {
            opacity: 1,
            width: 162,
        },
    },
    customSquare: {
        height: 25,
        width: 25,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
});
